/* eslint-disable no-underscore-dangle */
import React, { useMemo, useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import {
  Text, FormErrorMessage, Image, Icon, Clamp,
} from 'components/atoms';
import { MediaUploadGallery } from 'containers'
import { useToggle } from 'hooks';
import { mediaType } from 'types'
import { useSetState } from 'react-use'

const FieldMedia = (props) => {
  const {
    formData, onChange, errorSchema
  } = props

  const [state, setState] = useSetState(formData)
  const [isHover, setHover] = useState(false);
  const [isOpen, toggle] = useToggle();

  useEffect(() => {
    onChange(state)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  const computedIsLocal = useMemo(
    () => (state && state.isLocal !== undefined ? state.isLocal : true),
    [state]
  );

  const hasImage = useMemo(() => state && state.url && state.url !== '', [state]);
  const hasAlt = useMemo(() => state && state.alt && state.alt !== '', [state]);
  const computedText = useMemo(() => {
    if (!hasImage) return 'Selecionar imagem';
    if (!hasAlt) return 'Sem descrição';
    return state.alt;
  }, [hasAlt, state, hasImage]);

  const error = useMemo(() => {
    if (
      errorSchema
      && errorSchema.url
      && errorSchema.url.__errors
      && errorSchema.url.__errors.length > 0
    ) {
      return errorSchema.url.__errors[0]
    }
    return null
  }, [errorSchema])

  const handleClick = () => {
    toggle()
  };

  const handleChange = (img) => {
    setState({
      ...img,
      isLocal: false,
    })
  }

  return (
    <div>
      <MediaUploadGallery
        isOpen={isOpen}
        toggle={toggle}
        initialImage={state}
        onSubmit={handleChange}
      />
      <ImageInput
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={handleClick}
      >
        <ImageWrapper hasImage={hasImage} isHover={isHover}>
          {isHover && hasImage && (
            <ImageHover>
              <Icon height={16} color="#FFF" icon="edit" />
            </ImageHover>
          )}
          {hasImage ? (
            <Image src={state.url} alt={state.alt} isPortal={computedIsLocal} height={36} />
          ) : (
            <Icon icon="add_photo" color="#FFF" height={20} />
          )}
        </ImageWrapper>
        {hasImage ? (
          <Clamp>
            <Text>{computedText}</Text>
          </Clamp>
        ) : (
          <Text modifiers={['lighter']}>Selecionar imagem</Text>
        )}
      </ImageInput>
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
      <InputSpacingFix />
    </div>
  );
}

const ImageInput = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: ${props => props.theme.values.borderSize} solid
    ${props => props.theme.colors.base};
  padding: ${props => `${props.theme.spacing.xs2} 0`};
  align-items: flex-start;
  cursor: pointer;
`;

// this spacing is used below the error message, this makes the margin feel more natural
// when the error happears and disappears
const InputSpacingFix = styled.div`
  height: ${props => props.theme.spacing.m};
  width: 100%;
`;


const ImageWrapper = styled.div`
  position: relative;
  height: 36px;
  width: calc(36px * 16 / 9);
  background-color: ${({ hasImage, isHover, theme }) => {
    if (hasImage) return theme.colors.bg;
    if (isHover && !hasImage) return theme.colors.primary;
    return theme.colors.bgLighterS;
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${props => props.theme.spacing.xs2};
`;

const ImageHover = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.bgHover};
`;

FieldMedia.propTypes = {
  formData: mediaType,
  errorSchema: PropTypes.shape({
    url: PropTypes.shape({
      __errors: PropTypes.arrayOf(PropTypes.string)
    })
  }),
  onChange: PropTypes.func,
}

FieldMedia.defaultProps = {
  formData: {},
  onChange: () => { },
  errorSchema: {},
}

export default FieldMedia
